<template>
  <div
    class="no-data"
    :class="['no-data--' + variant]">
    <CyAvatar
      v-if="icon"
      class="mb-6"
      icon-size="32"
      :item="{ icon: icon, color: color }"/>
    <div class="no-data__title">
      {{ title }}
    </div>
    <p class="no-data__text">
      {{ text }}
    </p>
    <div v-if="$slots.link">
      <slot name="link"/>
      <v-icon
        color="grey"
        size="small">
        open_in_new
      </v-icon>
    </div>
    <div v-if="$slots.actions">
      <slot name="actions"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CyEmptyData',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'dev',
    },
    variant: {
      type: String,
      default: 'bordered',
      validator: (value) => ['bordered', 'default'].includes(value),
    },
  },
}
</script>

<style lang="scss" scoped>

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.3rem;
  padding: 32px;
  border-radius: 0.5rem;
  text-align: center;

  &--bordered {
    border: 1px dashed cy-get-color("primary", "light-4");
  }

  &__title {
    margin-bottom: 0.5rem;
    color: cy-get-color("primary");
    font-size: $font-size-lg;
    font-weight: $font-weight-bold;
  }

  &__text {
    max-width: 520px;
    margin-bottom: 16px;
    color: cy-get-color("primary", "light-2");
  }
}

</style>
